module.exports = __webpack_public_path__ + "fonts/GillSansStd-Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./apps/assets/fonts/GillSansStd-Light.ttf
// module id = 88
// module chunks = 0